import { Button } from 'antd';
import { memo } from 'react';
import { Modal } from 'react-bootstrap';
import ReactHlsPlayer from 'react-hls-player';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ModalCamera =memo(({ setShow, show, deviceId }) => {
  const { t } = useTranslation();
  const camera = useSelector((state) => state.attribute.camera);

  const handleClose = () => setShow(false);

  return (
    <Modal onHide={handleClose} show={show} scrollable size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>{t('monitor-scene')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {camera?.result ?
        <div style={{ width: '100%', height: 'auto' }}>
          <ReactHlsPlayer
            style={{ width: '100%', height: '100%' }}
            src={camera?.result?.data?.streams?.[0]?.hls}
            autoPlay={true}
            muted
          />
        </div>
        :
        <p className="text-center">{t('no-video')}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t('close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
});

export default ModalCamera;
